import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useAuthority } from '../../utils/Authorizable/authorize'
import { Route } from '../../routes/Route'
import { currentUserHomepageSelector } from '../../redux/session/currentUser/selectors'

interface AuthorityRouteGuardProps {
  // Injected automatically by AppRouter's cloneRoute for every route element - not passed explicitly.
  route?: Route
}

const AuthorityRouteGuard: React.FC<AuthorityRouteGuardProps> = ({ route }) => {
  const authorized = useAuthority(route?.authority)
  const homepage = useSelector(currentUserHomepageSelector)

  if (!authorized) return <Navigate to={homepage} replace />

  return <Outlet />
}

export default AuthorityRouteGuard
